import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Menu } from './menu.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {



  constructor(private http: HttpClient, private global: Globle, private localStorage: LocalStorageService) {


  }


  getAll() {
    return this.http.get<Menu[]>(this.global.APIURL + "menu");
  }

  getById(id: number) {
    return this.http.get<Menu>(this.global.APIURL + "menu/" + id);
  }

  Create(menu: any) {
    return this.http.post(this.global.APIURL + "menu", menu)
  }

  Update(menu: any) {
    return this.http.put(this.global.APIURL + "menu", menu)
  }

  Delete(id: number) {
    return this.http.delete(this.global.APIURL + "menu/" + id)
  }
}
